import {
  BrowserRouter,
  Link,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Login from "./Mainpages/Login";
import Dashboard from "./Mainpages/Dashboard";
import Customers from "./Mainpages/Customers";
import Dairy from "./Mainpages/Dairy";
import Orders from "./Mainpages/Orders";
import Payments from "./Mainpages/Payments";
import Subscriptions from "./Mainpages/Subscriptions";
import ProfilePage from "./Mainpages/ProfilePage";
import Password from "./Mainpages/Password";
import Coupons from "./Mainpages/Coupons";
import Plans from "./Mainpages/Plans";
import GeneralRateList from "./Mainpages/GeneralRateList";
import CustomerDetailpage from "./Editpages/CustomerDetailpage";
import CouponDetailpage from "./Editpages/CouponDetailpage";
import AddCouponPage from "./Addpages/AddCouponPage";
import PlanDetailpage from "./Editpages/PlanDetailpage";
import AddPlanPage from "./Addpages/AddPlanPage";
import OtpVerification from "./Mainpages/OtpVerification";
import CustomerDairyRateList from "./Mainpages/CustomerDairyRateList";
import AddRateListPage from "./Addpages/AddRateListPage";
import EditRateListPage from "./Editpages/RateListPage";
import CustomerLogin from "./Mainpages/CustomerLogin";
import Subscriptiondetail from "./Editpages/Subscriptiondetail";
import Offers from "./Mainpages/Offer";
import OfferDetailpage from "./Editpages/OfferDetailpage";
import AddOfferPage from "./Addpages/AddOfferPage";
import Forgotpassword from "./Mainpages/Forgotpassword";
import PageNotFound from "./Mainpages/PageNotFound";
import CustomerallDetailpage from "./Editpages/CustomerallDetailpage";
import Refferal from "./Mainpages/Refferal";
import {
  apiAxiosInstance,
  authAxiosInstance,
  initiateOAuthFlowWithAxios,
} from "./utils/AxiosAuthClient";
import axios from "axios";

import { useDispatch, useSelector } from "react-redux";
import { AUTH_BASE_URL } from "./Config/Config";
import ResetPassword from "./Mainpages/ResetPassword";
import { getLogin, getToken, getTokenReady, getUserDetail, logout, updateUserDetail } from "./features/Loginuser";
import { setCoupanData } from "./features/Coupon";
import { setplans } from "./features/Plan";
import Home from "./Mainpages/Home";
import PublicRoutes from "./PublicRoutes";
import ProtectedRoute from "./ProtectedRoutes";
import { useSilentAuth } from "./hooks/useSilentAuth";

function App() {
  const dispatch = useDispatch();
  const { triggerSilentFlow } = useSilentAuth();
  const [checkingSession, setCheckingSession] = useState(true); // State to track session check
  const location = useLocation(); // Get current location for potential redirects after login
  const navigate = useNavigate();
  const tokenReady = useSelector(getTokenReady);
  const login = useSelector(getLogin);
  const token = useSelector(getToken);
  const userDetail = useSelector(getUserDetail);
  useEffect(() => {
    async function checkUserLoginStatus() {
      try {
        setCheckingSession(true); // Start session check
        // Crucial: include credentials so the browser sends the JSESSIONID cookie
        const response = await authAxiosInstance.get("/auth/session");
        const responseData = response.data;
        if (responseData.data.authenticated) {
          await triggerSilentFlow(); // Initiate OAuth flow if session is valid
          navigate(location.pathname); // Redirect to the original location after successful login
          return; // User is authenticated, no action needed
        } else {
          dispatch(logout());
          navigate("/login");
        }
      } catch (error) {
        dispatch(logout());
        navigate("/login");
      }
    }
    if (login) {
      checkUserLoginStatus();
    }
  }, [login]);

  const fetchedRef = useRef(false);

  useEffect(() => {
    if (!tokenReady) return;

    if (fetchedRef.current) return;

    fetchedRef.current = true;

    loadUserData();
    getplan();
    getcoupon();
  }, [tokenReady]);

  async function loadUserData() {
    try {
      const userInfoResponse = await fetch(`${AUTH_BASE_URL}/userinfo`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const userData = await userInfoResponse.json();
      const updatedDetail = { ...userDetail, ...userData };
      dispatch(updateUserDetail(updatedDetail));
    } catch (error) {
      console.error("Failed to load user info:", error);
    }
  }

  async function getplan() {
    // Use axios with automatic session handling
    apiAxiosInstance
      .get("plans?page=", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        dispatch(setplans(response.data.result.data));
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          dispatch(logout());
        } else {
          console.error("Error fetching plans:", error);
        }
      });
  }

  async function getcoupon() {
    // Use axios with automatic session handling
    apiAxiosInstance
      .get("coupon?page=", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        dispatch(setCoupanData(response.data.result.data));
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          dispatch(logout());
        } else {
          console.error("Error fetching coupons:", error);
        }
      });
  }

  return (
    <Routes>
      {/* Public */}

      {/* Public */}

      <Route
        path="/"
        element={
          <PublicRoutes>
            <Home/>
          </PublicRoutes>
        }
      />

      <Route
        path="/login"
        element={
          <PublicRoutes>
            <Login />
          </PublicRoutes>
        }
      />

      <Route
        path="/otpverification"
        element={
          <PublicRoutes>
            <OtpVerification />
          </PublicRoutes>
        }
      />

      <Route
        path="/forgotpassword"
        element={
          <PublicRoutes>
            <Forgotpassword />
          </PublicRoutes>
        }
      />

      <Route
        path="/resetpassword"
        element={
          <PublicRoutes>
            <ResetPassword />
          </PublicRoutes>
        }
      />

      {/* Protected */}

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customers"
        element={
          <ProtectedRoute>
            <Customers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customers/:customer_id"
        element={
          <ProtectedRoute>
            <CustomerDetailpage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customers/details/:customer_id"
        element={
          <ProtectedRoute>
            <CustomerallDetailpage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customerlogin/:customer_id"
        element={
          <ProtectedRoute>
            <CustomerLogin />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dairy"
        element={
          <ProtectedRoute>
            <Dairy />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dairy/:id/:name"
        element={
          <ProtectedRoute>
            <CustomerDairyRateList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />

      <Route
        path="/payments"
        element={
          <ProtectedRoute>
            <Payments />
          </ProtectedRoute>
        }
      />

      <Route
        path="/subscriptions"
        element={
          <ProtectedRoute>
            <Subscriptions />
          </ProtectedRoute>
        }
      />

      <Route
        path="/subscriptions/:subscription_id"
        element={
          <ProtectedRoute>
            <Subscriptiondetail />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profilePage"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <Password />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coupons"
        element={
          <ProtectedRoute>
            <Coupons />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coupons/addcoupon"
        element={
          <ProtectedRoute>
            <AddCouponPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coupons/:coupon_id"
        element={
          <ProtectedRoute>
            <CouponDetailpage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/offers"
        element={
          <ProtectedRoute>
            <Offers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/offers/addoffer"
        element={
          <ProtectedRoute>
            <AddOfferPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/offers/:offer_id"
        element={
          <ProtectedRoute>
            <OfferDetailpage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/plans"
        element={
          <ProtectedRoute>
            <Plans />
          </ProtectedRoute>
        }
      />

      <Route
        path="/plans/:plan_id"
        element={
          <ProtectedRoute>
            <PlanDetailpage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/plans/addplan"
        element={
          <ProtectedRoute>
            <AddPlanPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/ratelist"
        element={
          <ProtectedRoute>
            <GeneralRateList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/ratelist/:rate_list_id"
        element={
          <ProtectedRoute>
            <EditRateListPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/ratelist/addratelist"
        element={
          <ProtectedRoute>
            <AddRateListPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/refferal"
        element={
          <ProtectedRoute>
            <Refferal />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
